import React from "react";
import "./../styles/variable-projects.css";
import Projectsvariable from "../components/variable-projects";
import imagem1 from '../assets/images/Projetos/Mineração/mineracao.jpg';
import imagem2 from '../assets/images/Projetos/Mineração/mineraçao-img2.jpg';
import imagem3 from '../assets/images/Projetos/Mineração/mineraçao-img3.jpg';

const App = () => {
  const projectData = {
    date: "26/03/2018",
    title: "Mineração",
    images: [
      imagem1,
      imagem2,
      imagem3
    ],
    description:
    "Atendemos os principais nome do setor de Mineração, atuando com as soluções abaixo para nomes como a Vale por exemplo",
    solutions: ["Solução VHF, Coberturas WI-FI"],
  };

  return <Projectsvariable {...projectData} />;
};

export default App;